import { render, staticRenderFns } from "./PostImages.vue?vue&type=template&id=434349a7&scoped=true"
import script from "./PostImages.vue?vue&type=script&lang=js"
export * from "./PostImages.vue?vue&type=script&lang=js"
import style0 from "./PostImages.vue?vue&type=style&index=0&id=434349a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434349a7",
  null
  
)

export default component.exports